import React from 'react';

const AuthInfoStatus = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3519_41665)">
        <path
          d="M11.9687 3.23828C14.4883 3.23828 16.9047 4.23917 18.6863 6.02077C20.4679 7.80236 21.4687 10.2187 21.4687 12.7383V12.7383C21.4687 15.2578 20.4679 17.6742 18.6863 19.4558C16.9047 21.2374 14.4883 22.2383 11.9687 22.2383V22.2383C9.44919 22.2383 7.03283 21.2374 5.25124 19.4558C3.46964 17.6742 2.46875 15.2578 2.46875 12.7383V12.7383C2.46875 10.2187 3.46964 7.80236 5.25124 6.02077C7.03283 4.23917 9.44919 3.23828 11.9687 3.23828V3.23828Z"
          stroke="#08081B"
          strokeWidth="0.96"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M16.1678 9.83203L10.4266 15.5733L7.875 13.0217"
          stroke="#08081B"
          strokeWidth="0.96"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3519_41665">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.707031)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default AuthInfoStatus;
